import { EXPLORE_ROUTES } from "./exploreRoutes";
import { QUIZ_ROUTES } from "./quizzes/quizRoutes";
import React, { useState } from "react";
import { buildQuizBackTarget } from './quizzes/quizFlowState';
import { DASHBOARD_ROUTES } from './dashboardRoutes';
import "./QuizzesSection.css";
import { useNavigate } from "react-router-dom";
import { mapAssessmentItem } from "../utils/dashboardContent";
import { getStoredUser } from "../utils/authStorage";

const tabs = [
  { id: "past", label: "Past" },
  { id: "ongoing", label: "Ongoing" },
  { id: "upcoming", label: "Upcoming" },
];

const QuizSection = ({
  title = "Quizzes",
  sectionData = { current: [], past: [], upcoming: [] },
  isLoading = false,
  error = "",
}) => {
  const [activeTab, setActiveTab] = useState("ongoing");
  const navigate = useNavigate();
  const storedUser = getStoredUser();
  const fallbackStateId = Number(
    storedUser?.state_id || storedUser?.stateId || storedUser?.user_state_id || 0
  );
  const fallbackStateName =
    storedUser?.state_name || storedUser?.stateName || storedUser?.user_state_name || "";
  const routeKey = title === "Quizzes" ? 1 : 2;
  const categoryId = 1;
  const quizData = {
    past: (Array.isArray(sectionData?.past) ? sectionData.past : []).map(mapAssessmentItem),
    ongoing: (Array.isArray(sectionData?.current) ? sectionData.current : []).map(mapAssessmentItem),
    upcoming: (Array.isArray(sectionData?.upcoming) ? sectionData.upcoming : []).map(mapAssessmentItem),
  };

  const activeQuizzes = quizData[activeTab];

  const handleStartQuiz = (quiz) => {
    navigate(QUIZ_ROUTES.start, {
      state: {
        selectedQuiz: {
          ...quiz,
          quiz_id: Number(quiz?.quizId || quiz?.id || 0),
          quizId: Number(quiz?.quizId || quiz?.id || 0),
        },
        selectedState: fallbackStateId
          ? {
              state_id: fallbackStateId,
              state_name: fallbackStateName,
            }
          : undefined,
        state_id: fallbackStateId || undefined,
        stateName: fallbackStateName,
        category_id: categoryId,
        route_key: routeKey,
        selectedQuizOption: title,
        quizBackTarget: buildQuizBackTarget(DASHBOARD_ROUTES.home, {}),
        quizListBackTarget: buildQuizBackTarget(DASHBOARD_ROUTES.home, {}),
      },
    });
  };

  return (
    <section className="quize-section">
        <div className="quick-action__header">
        <h2 className="quick-action__title">
          {title}
        </h2>

        {!isLoading ? (
          <button type="button" className="quick-action__see-all" onClick={() => navigate(EXPLORE_ROUTES.exams)}>
            See All
          </button>
        ) : (
          <span className="dashboard-skeleton dashboard-skeleton--button" aria-hidden="true" />
        )}
      </div>

      {!isLoading ? (
        <div className="quize-tabs" role="tablist">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.id}
              className={`quize-tab ${
                activeTab === tab.id ? "quize-tab--active" : ""
              }`}
              onClick={() => setActiveTab(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      ) : (
        <div className="dashboard-skeleton-tabs" aria-hidden="true">
          {Array.from({ length: 3 }).map((_, index) => (
            <span className="dashboard-skeleton dashboard-skeleton-tab" key={index} />
          ))}
        </div>
      )}

    <div className="quize-list">
      <div className="quiz-list__scroll">
        {isLoading ? (
          <div className="dashboard-skeleton-stack" aria-hidden="true">
            {Array.from({ length: 3 }).map((_, index) => (
              <div className="dashboard-skeleton-quiz-card" key={index}>
                <div className="dashboard-skeleton-quiz-main">
                  <span className="dashboard-skeleton dashboard-skeleton--icon" />
                  <div className="dashboard-skeleton-stack" style={{ flex: 1 }}>
                    <span className="dashboard-skeleton dashboard-skeleton--line dashboard-skeleton--title" />
                    <span className="dashboard-skeleton dashboard-skeleton--line dashboard-skeleton--text" />
                    <span className="dashboard-skeleton dashboard-skeleton--line dashboard-skeleton--text-short" />
                  </div>
                </div>
                <span className="dashboard-skeleton dashboard-skeleton--button" />
              </div>
            ))}
          </div>
        ) : null}
        {!isLoading && error ? <div className="quize-empty-state">{error}</div> : null}
        {!isLoading && !error && activeQuizzes.length > 0 ? (
          activeQuizzes.map((quiz) => (
            <article className="quize-card" key={quiz.id}>
              <div className="quize-card__left">
                <div className="quize-card__icon"> 01  </div>

                <div className="quize-card__content">
                  <h3 className="quize-card__title">{quiz.title}</h3>

                  <div className="quize-card__details">
                    <span>{quiz.duration}</span>
                    <span>{quiz.questions}</span>
                    <span>{quiz.marks}</span>
                    <span>Attempts: {quiz.attempts}</span>
                  </div>

                  <div className="quize-card__footer">
                    <span className="quize-card__languages">
                      {quiz.languages}
                    </span>

                    <span className="quize-card__separator">|</span>

                    <span
                      className={`quize-card__status quize-card__status--${activeTab}`}
                    >
                      {quiz.status}
                    </span>
                  </div>
                </div>
              </div>

           <button
              type="button"
              className="quize-card__action"
              onClick={() => handleStartQuiz(quiz)}
            >
               Practice Now
            </button>
            </article>
          ))
        ) : !isLoading && !error ? (
          <div className="quize-empty-state">
            No {title.toLowerCase()} available in this section.
          </div>
        ) : null}
      </div>
      </div>
    </section>
  );
};

export default QuizSection;
